module.exports = __webpack_public_path__ + "img/402(1).03dbb11d.svg";